import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Detail from "./routes/Detail";
import Favorites from "./routes/Favorites";
import Home from "./routes/Home";
import "./App.css";

function App() {
  // 앱의 최상위 라우팅 구성.
  // 모든 화면 진입점은 이 파일에서 정의된다.
  return (
    <Router>
      <Routes>
        {/* 메인 목록 화면 */}
        <Route path="/" element={<Home />} />
        {/* 영화 상세 화면: 영화 id를 URL 파라미터로 전달 */}
        <Route path="/detail/:id" element={<Detail />} />
        {/* 즐겨찾기 목록 화면 */}
        <Route path="/favorites" element={<Favorites />} />
        {/* 정의되지 않은 경로는 홈으로 리다이렉트 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
